// @flow

import React from 'react'
import viewsIcon from '../../Icons/icon-views.svg'
import Loading from '../../Icons/loading.gif'
import { Link } from 'react-router-dom'
import Row from 'michelangelo/dist/Components/Row'
import Column from 'michelangelo/dist/Components/Column'

type Props = {
  loading: boolean,
  title: string,
  totalViews: number,
  contentId: number
}

function ContentBlock ({ loading, title, totalViews, contentId }: Props) {
  const emptyTotalViews = totalViews === null || totalViews === undefined
  const totalViewsFormatted = !emptyTotalViews
    ? totalViews.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    : ''

  const LoadingIndicator = () => (<div><img src={Loading} alt='Loading' /></div>)

  return (
    <div className='BlockItem' style={{ flexBasis: '20%' }}>
      <h4>Content</h4>
      {loading && <LoadingIndicator />}
      {!loading && (
        <Row>
          <Column classNames={['is-12 is-12-desktop']}>
            <div className='BlockHeaderWrapper'>
              {contentId !== '0'
                ? <Link to={{ pathname: '/content', search: `?id=${contentId}` }}><h3 className='HeaderLink'> {title} </h3></Link>
                : <h3> {title} </h3>
              }
              <h5 className='BlockSubHeader'> Most Viewed </h5>
            </div>
            {emptyTotalViews || totalViews === 0
              ? <p><img src={viewsIcon} alt='View' /> No Views</p>
              : <p><img src={viewsIcon} alt='View' /> {totalViewsFormatted} Views</p>}
          </Column>
        </Row>
      )}
    </div>
  )
}

export default ContentBlock
